module.exports = __webpack_public_path__ + "img/broadband.8350722.svg";